L.ContextMenu = L.Layer.extend({
  initialize: function (latlng, $compile, sections, $scope) {
    this._latlng = latlng;
    this.$compile = $compile;
    this.$scope = $scope.$new();

    this.$scope.sections = sections;
    this.$scope.select = (section, item, e) => {
      e.stopPropagation();

      let func = typeof item.onSelect == "function" ? item.onSelect : section.onSelect,
        map = this._map;
      this._map.removeLayer(this);
      func(item, map, this._latlng);
    };
  },

  onAdd: function (map) {
    this._map = map;

    // create a DOM element and put it into one of the map panes
    this._el = L.DomUtil.create("div", "context-menu leaflet-zoom-hide");
    $(this._el).append(this.$compile('<span context-menu class="leaflet-zoom-hide" sections="sections" select="select"></span>')(this.$scope).get(0));
    map.getPanes().overlayPane.appendChild(this._el);

    // add a viewreset event listener for updating layer's position, do the latter
    map.on("viewreset", this._reset, this);
    this._reset();
  },

  onRemove: function (map) {
    // remove layer's DOM elements and listeners
    map.getPanes().overlayPane.removeChild(this._el);
    map.off("viewreset", this._reset, this);
  },

  _reset: function () {
    // update layer's position
    var pos = this._map.latLngToLayerPoint(this._latlng);
    L.DomUtil.setPosition(this._el, pos);
  },
});
